import { useDispatch, useSelector } from "react-redux";
import { getGiftPopup, openConfirmGiftPopup } from "../../../redux/actions";
import React, { useState } from "react";
import hyphen from "../../../utils/hyphen";
import style from './giftPopup.module.scss';
import { NotAuthorizedPopup } from "../notAuthorizedPopup/NotAuthorizedPopup";
export const GiftPopup = () => {
    const dispatch = useDispatch();
    const isLogin = useSelector(state => state.user.isLogin);
    const giftPopup = useSelector(state => state.user.giftPopup);
    const lang = useSelector(state => state.app.currentLang)
    const [notAuthPopup, setNotAuthPopup] = useState({ isOpen: null, giftName: '' })

    if (giftPopup === null) {
        return null;
    }
    const closeNotAuthPopup = () => {
        setNotAuthPopup({ isOpen: false, giftName: '' })
    }

    const handleClick = () => {
        if (isLogin) {
            dispatch(openConfirmGiftPopup())
        } else {
            setNotAuthPopup({ isOpen: true, giftName: giftPopup.name ?? '' })
        }
    }

    return (
        <div className={style["giftPopup"]}>
            <div className={style["giftPopup__back"]} onClick={() => dispatch(getGiftPopup(null))}></div>
            <div className={style["giftPopup__wrap"]}>
                <div className={style["giftPopup__box"]}>
                    <div className={style["giftPopup__head"]}>
                        <div className={style["giftPopup__label"]}>
                            {
                                giftPopup.showQuantity ? ((giftPopup.leftQuantity ?? 0) + '/' + (giftPopup.totalQuantity ?? 0)) : ''
                            }
                        </div>

                        <div className={style["giftPopup__close_btn"]} onClick={() => dispatch(getGiftPopup(null))}></div>
                    </div>
                    <div className={style["giftPopup__img"]}>
                        {
                            giftPopup.image && (<img src={giftPopup.image} alt="" title="" />)
                        }
                        {
                            !giftPopup.image && (<div className={style["giftPopup__img_def"]}></div>)
                        }
                    </div>
                    <div className={style["giftPopup__body"]}>
                        {giftPopup.name && <div className={style["giftPopup__name"]}>{hyphen(giftPopup.name)}</div>}
                    </div>
                    <div className={style['giftPopup__footer']}>
                        <button className={style['giftPopup__button']} onClick={handleClick}>
                            {lang.gift.popup.button}
                            <span className={style['giftPopup__button_coin']}></span>
                            {giftPopup.price}
                        </button>
                        {giftPopup.description && <p className={style['giftPopup__description']}
                            dangerouslySetInnerHTML={{ __html: hyphen(giftPopup.description).replaceAll("\n", '<br>')}} />
                        }
                    </div>

                </div>
            </div>
            {
                notAuthPopup.isOpen && <NotAuthorizedPopup title={notAuthPopup.giftName} close={closeNotAuthPopup} />
            }
        </div>
    )
}